import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import {
  dashboardTotalsYesterdaySelector,
  dashboardTotalsCurrentMonthSelector,
  dashboardTotalsLastMonthSelector,
} from '../../state';
import TotalsCard from '../TotalsCard';
import { DashboardTotalsByCountry } from '../../types';

type Lapse = 'yesterday' | 'currentMonth' | 'lastMonth';

const DashboardTotalsCards = ({ lapse }: { lapse: Lapse }) => {
  const yesterdayResource = useSelector(dashboardTotalsYesterdaySelector);
  const currentMonthResource = useSelector(dashboardTotalsCurrentMonthSelector);
  const lastMonthResource = useSelector(dashboardTotalsLastMonthSelector);

  const selected = (() => {
    switch (lapse) {
      case 'yesterday':
        return {
          title: 'dashboard.time_tabs.yesterday',
          data: (yesterdayResource?.data as DashboardTotalsByCountry[]) || [],
          loading: !!yesterdayResource?.loading,
        };
      case 'currentMonth':
        return {
          title: 'dashboard.time_tabs.current_month',
          data: (currentMonthResource?.data as DashboardTotalsByCountry[]) || [],
          loading: !!currentMonthResource?.loading,
        };
      case 'lastMonth':
      default:
        return {
          title: 'dashboard.time_tabs.last_month',
          data: (lastMonthResource?.data as DashboardTotalsByCountry[]) || [],
          loading: !!lastMonthResource?.loading,
        };
    }
  })();

  return (
    <Box width="100%" data-guide={`dashboard-totals-${lapse}`}>
      <TotalsCard title={selected.title} data={selected.data} loading={selected.loading} />
    </Box>
  );
};

export default DashboardTotalsCards;
